import React from 'react'

const Footer = () => {
    return (
        <footer>&copy; by The Atomic Blog ✌️</footer>
    )
}

export default Footer
